module.exports = __webpack_public_path__ + "dashboard.39509c3f61e20f9c6fd5135c8f3fa3ff.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/menu/dashboard.svg
// module id = 331
// module chunks = 0